export default function Copyright() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold mb-8">Copyright Notice</h1>

        <div className="space-y-8">
          <section className="bg-gray-800/50 rounded-lg p-8">
            <h2 className="text-2xl font-bold mb-4">Junk.fun Platform</h2>
            <p className="text-2xl font-semibold text-cyan-400 mb-4">
              Copyright © 2026 Junk.fun. All Rights Reserved.
            </p>
          </section>

          <section className="bg-gray-800/50 rounded-lg p-8">
            <h2 className="text-2xl font-bold mb-4">Ownership</h2>
            <p className="text-gray-300 mb-4">
              The Junk.fun platform and all associated applications, including but not limited to:
            </p>
            <ul className="list-disc list-inside text-gray-300 space-y-2">
              <li>Source code</li>
              <li>User interface design</li>
              <li>Graphics, logos, and icons</li>
              <li>Documentation</li>
              <li>Smart contract implementations</li>
            </ul>
            <p className="text-gray-300 mt-4">
              is owned by Junk.fun and protected by copyright laws and international treaty provisions.
            </p>
          </section>

          <section className="bg-gray-800/50 rounded-lg p-8">
            <h2 className="text-2xl font-bold mb-4">License</h2>
            <p className="text-gray-300">
              This software is licensed under the MIT License. See the <a href="/license" className="text-cyan-400 hover:underline">LICENSE</a> file for full details.
            </p>
          </section>

          <section className="bg-gray-800/50 rounded-lg p-8">
            <h2 className="text-2xl font-bold mb-4">Trademarks</h2>
            <p className="text-gray-300">
              "Junk.fun" and the Junk.fun logo are trademarks of Junk.fun. All rights reserved.
            </p>
          </section>

          <section className="bg-gray-800/50 rounded-lg p-8">
            <h2 className="text-2xl font-bold mb-4">Third-Party Components</h2>
            <p className="text-gray-300 mb-4">
              Our platform includes open-source components licensed under their respective licenses:
            </p>
            <ul className="list-disc list-inside text-gray-300 space-y-2">
              <li>React - MIT License</li>
              <li>Solana Web3.js - Apache 2.0</li>
              <li>Anchor Framework - Apache 2.0</li>
              <li>Expo SDK - MIT License (mobile)</li>
              <li>Other dependencies as listed in package.json files</li>
            </ul>
          </section>

          <section className="bg-gray-800/50 rounded-lg p-8">
            <h2 className="text-2xl font-bold mb-4">Smart Contract</h2>
            <p className="text-gray-300 mb-4">
              The Junk.fun Solana program is deployed at:
            </p>
            <code className="block bg-gray-900 p-4 rounded text-cyan-400 font-mono text-sm break-all">
              junkTHpAet6MuYuTfHej12Zh12aWeG6tXbB7hnLjTKi
            </code>
            <p className="text-gray-300 mt-4">
              Program code is open source and auditable on the Solana blockchain.
            </p>
          </section>

          <section className="bg-gray-800/50 rounded-lg p-8">
            <h2 className="text-2xl font-bold mb-4">Attribution</h2>
            <p className="text-gray-300 mb-4">
              When redistributing or referencing this software, please include:
            </p>
            <ul className="list-disc list-inside text-gray-300 space-y-2">
              <li>A copy of the LICENSE file</li>
              <li>This copyright notice</li>
              <li>A link to <a href="https://junk.fun" className="text-cyan-400 hover:underline">https://junk.fun</a></li>
            </ul>
          </section>

          <section className="bg-gray-800/50 rounded-lg p-8">
            <h2 className="text-2xl font-bold mb-4">Contact</h2>
            <p className="text-gray-300 mb-4">
              For copyright inquiries or permissions beyond the scope of the MIT License:
            </p>
            <ul className="list-none text-gray-300 space-y-2">
              <li>Website: <a href="https://junk.fun" className="text-cyan-400 hover:underline">https://junk.fun</a></li>
              <li>Email: legal@junk.fun</li>
            </ul>
          </section>

          <div className="text-center text-gray-400 mt-12">
            <p>Last Updated: January 26, 2026</p>
          </div>
        </div>
      </div>
    </div>
  );
}
